import React from 'react';

type ContainerProps = React.HTMLProps<{}>;

export const Container: React.VFC<ContainerProps> = ({
  id,
  width,
  height,
  children,
}) => {
  return (
    <div id={id} style={{ width, height, border: '1px solid red' }}>
      {React.cloneElement(children as React.ReactElement<any>, {
        containerWidth: width,
        containerHeight: height,
      })}
    </div>
  );
};
